import * as React from 'react';
export const metamaskSvg = React.forwardRef(function metamaskSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm25.904 6-8.584 6.375 1.588-3.762L25.904 6Z',
      fill: '#E2761B',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm6.088 6 8.514 6.435-1.51-3.822L6.088 6Zm16.728 14.778-2.287 3.504 4.892 1.346 1.406-4.772-4.011-.078Zm-17.635.078 1.398 4.771 4.892-1.345-2.287-3.503-4.003.077Z',
      fill: '#E4761B',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm11.194 14.86-1.361 2.063 4.857.215-.172-5.219-3.322 2.942-.002-.002Zm9.603 0-3.365-3.003-.111 5.28 4.848-.214-1.372-2.063Zm-9.326 9.422 2.916-1.424-2.52-1.967-.396 3.39Zm6.134-1.424 2.924 1.424-.405-3.392-2.52 1.968Z',
      fill: '#E4761B',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm20.53 24.282-2.925-1.424.232 1.907-.026.802 2.718-1.285Zm-9.06 0 2.718 1.285-.017-.803.215-1.907-2.915 1.425Z',
      fill: '#D7C1B3',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm14.231 19.631-2.432-.716 1.716-.785.716 1.501Zm3.529 0 .716-1.502 1.725.786-2.441.716Z',
      fill: '#233447',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm11.47 24.282.415-3.503-2.7.077 2.286 3.425Zm8.646-3.504.413 3.504 2.287-3.426-2.7-.078Zm2.053-3.855-4.849.215.449 2.493.716-1.501 1.725.785 1.959-1.992Zm-10.37 1.992 1.725-.785.707 1.501.458-2.494-4.856-.214 1.966 1.992Z',
      fill: '#CD6116',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm9.832 16.922 2.036 3.97-.07-1.977-1.966-1.993Zm10.378 1.993-.086 1.975 2.045-3.967-1.959 1.992Zm-5.521-1.777-.458 2.493.57 2.942.129-3.874-.24-1.56-.001-.002Zm2.631 0-.232 1.552.103 3.883.578-2.942-.448-2.494Z',
      fill: '#E4751F',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm17.811 25.567.027-.803-.216-.189H14.37l-.199.19.017.802-2.717-1.285.949.776 1.924 1.337h3.303l1.933-1.337.95-.776-2.719 1.285Z',
      fill: '#C0AD9E',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm17.605 22.858-.414-.285H14.8l-.414.285-.216 1.906.198-.19 3.253.001.216.19-.233-1.908v.001Z',
      fill: '#161616',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M26.266 12.79 27 9.27 25.904 6l-8.3 6.16 3.193 2.7 4.512 1.32 1.001-1.164-.432-.311.69-.63-.534-.414.69-.526-.458-.346ZM5 9.27l.734 3.52-.467.345.69.526-.526.414.69.63-.431.31.993 1.165 4.511-1.32 3.193-2.7L6.087 6 5 9.27Z',
      fill: '#763D16',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm17.769 19.631-.578 2.942.414.285 2.52-1.968.085-1.975-2.441.716Zm-5.97-.716.069 1.976 2.518 1.966.415-.284-.57-2.942-2.432-.716Z',
      fill: '#F6851B',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm25.309 16.18-4.512-1.32 1.372 2.063-2.045 3.967 2.692-.034h4.011L25.31 16.18Zm-14.115-1.32-4.511 1.32-1.502 4.676h4.003l2.684.035-2.036-3.97 1.362-2.061Zm6.126 2.277.285-4.977 1.311-3.546-5.824-.001 1.295 3.547.302 4.977.102 1.57.01 3.866h2.39l.017-3.865.112-1.57Z',
      fill: '#F6851B',
    }),
  );
});
metamaskSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var metamask = {
  category: 'brand',
  colorable: false,
  name: 'metamask',
  svg: metamaskSvg,
};
